// Required environment variables:
// VITE_SENTRY_DSN         — Sentry DSN from project settings (client-side)
// VITE_APP_VERSION        — App version string e.g. "1.0.0" (optional)
// SENTRY_AUTH_TOKEN       — Sentry auth token for source map upload (CI only)
// SENTRY_ORG              — Sentry organisation slug (CI only)
// SENTRY_PROJECT          — Sentry project slug (CI only)

import * as Sentry from "@sentry/react";
import { version } from "../../package.json";

export function initialiseSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN || "https://1716d17ec104d266a6ee73057f460c1e@o4511217711775744.ingest.de.sentry.io/4511217730781264";

  if (!dsn) {
    console.warn("[Sentry] VITE_SENTRY_DSN not set — error tracking disabled");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: version,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance — sample 10% in production, 100% in dev
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Session replay — 10% of sessions, 100% of error sessions
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Don't track localhost
    enabled: import.meta.env.PROD || import.meta.env.MODE === "staging",

    beforeSend(event) {
      // Strip PII before sending
      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }
      if (event.request?.cookies) {
        delete event.request.cookies;
      }
      return event;
    },
  });
}

export { Sentry };
